import { Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import WushCard from "../../components/layout/WushCard";
import { Assignment, AttachMoney, CreditCard, LocalShipping, LocationSearchingRounded, Storefront } from "@mui/icons-material";

const INTEGRATIONS = [
  {
    key: 'stripe',
    label: 'Stripe',
    url: '/configuration/stripe',
    icon: <CreditCard sx={{ m: 'auto' }} fontSize="large" />,
    description: 'Configure your stripe integration here'
  }
];

const SALES = [
  {
    key: 'storefront',
    label: 'Storefront',
    url: '/configuration/storefront',
    description: 'Configure your storefront here',
    icon: <Storefront sx={{ m: 'auto' }} fontSize="large" />,
  }
];

const FINANCE = [
  {
    key: 'taxes',
    label: 'Taxes',
    url: '/configuration/taxes',
    description: 'Configure your taxes here',
    icon: <AttachMoney sx={{ m: 'auto' }} fontSize="large" />,
  }
];

const DELIVERY = [
  {
    key: 'delivery',
    label: 'Deliverable Zip Codes',
    url: '/configuration/delivery_zip_codes',
    description: 'Manage deliverable zip codes here',
    icon: <LocalShipping sx={{ m: 'auto' }} fontSize="large" />,
    comingSoon: true
  },
  {
    key: 'delivery',
    label: 'Town Delivery Zones',
    url: '/configuration/delivery_zip_codes',
    description: 'Manage deliverable zip codes here',
    icon: <LocationSearchingRounded sx={{ m: 'auto' }} fontSize="large" />,
    comingSoon: true
  }
];

const LEGAL = [
  {
    key: 'waivers',
    label: 'Waivers',
    url: '/configuration/waivers',
    description: 'Manage waivers here',
    icon: <Assignment sx={{ m: 'auto' }} fontSize="large" />
  }
];

const SETTINGS = [
  {
    label: 'Integrations',
    settings: INTEGRATIONS
  },
  {
    label: 'Sales',
    settings: SALES
  },
  {
    label: 'Fulfillment',
    settings: DELIVERY
  },
  {
    label: 'Finances',
    settings: FINANCE
  },
  {
    label: 'Legal',
    settings: LEGAL
  }
];

export default function Configuration() {
  const navigate = useNavigate();

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Configuration
        </Typography>
        <Typography variant="body1">
          Configure your application here.
        </Typography>
      </Stack>
      {SETTINGS.map((setting) => (
        <Stack key={setting.label}>
          <Stack mb={1}>
            <Typography variant="h5">
              {setting.label}
            </Typography>
          </Stack>
          <Grid container spacing={2} mb={4}>
            {setting.settings.map((setting) => (
              <Grid item xs={12} sm={4} key={setting.key}>
                <WushCard
                  onClick={() => navigate(setting.url)}
                  disabled={setting.comingSoon}
                >
                  <Grid container p={2} spacing={1}>
                    <Grid item sm={2} display="flex">
                      {setting.icon}
                    </Grid>
                    <Grid item sm={10}>
                      <Typography variant="h5">
                        {setting.label}
                      </Typography>
                      <Typography variant="body1">
                        {setting.comingSoon ? "Coming soon!" : setting.description}
                      </Typography>
                    </Grid>
                  </Grid>
                </WushCard>
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </Stack>
  );
}